import { FormControl, FormField, FormItem, FormMessage } from "@dune/ui";
import { PriceInput, PriceInputProps } from "./PriceInput";
import { Control, FieldPath, FieldValues } from "react-hook-form";

type ControlledPriceInputProps<T extends FieldValues> = {
	control: Control<T>;
	name: FieldPath<T>;
} & Pick<
	PriceInputProps,
	| "error"
	| "iconOrText"
	| "iconOrTextPosition"
	| "placeholder"
	| "label"
	| "required"
	| "readOnly"
	| "disabled"
	| "min"
	| "max"
>;

export const ControlledPriceInput = <T extends FieldValues>({
	control,
	name,
	...props
}: ControlledPriceInputProps<T>) => {
	return (
		<FormField
			control={control}
			name={name}
			render={({ field }) => {
				return (
					<FormItem className="w-full">
						<FormControl>
							<PriceInput
								{...field}
								value={field.value === "" ? undefined : Number(field.value)}
								{...props}
							/>
						</FormControl>
						<FormMessage />
					</FormItem>
				);
			}}
		/>
	);
};
